import { useContext } from 'react'
import CreationSourceVideoDescriptionField from '../../../../../../components/form-fields/super-cut/video-description'
import styled from 'styled-components'
import { CreationCaptureInfoContext } from '../manager'
import { Wrap } from 'shared/components/edit-panel/info/textfield-async'
import CreationToolUploadField from '../../../../../../types/upload-field'

const VideoDescription = styled(CreationSourceVideoDescriptionField)`
    grid-column: span 2;

    ${Wrap} {
        margin-bottom: 0px;
    }
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationCaptureInfoVideoDescriptionField = ({ className, field }: Props) => {
    const { description, setDescription } = useContext(CreationCaptureInfoContext)

    return (
        <VideoDescription
            {...{
                className,
                field,
                description,
                onChange: setDescription,
            }}
        />
    )
}

export default CreationCaptureInfoVideoDescriptionField
